// removed by extract-text-webpack-plugin
module.exports = {"fieldset":"radio-group__fieldset___1-YXA","legend":"radio-group__legend___1mHRR","itemContainer":"radio-group__item-container___2O7w8","item":"radio-group__item___auwO9","itemDisabled":"radio-group__item--disabled___1MnQT"};


//////////////////
// WEBPACK FOOTER
// ./js/components/radio-group/radio-group.scss
// module id = 254
// module chunks = 1